import { Toast } from 'antd-mobile';

/**
 * 未开发页面列表 已开发后去掉
 */
const noDevPageList = {
  classifyGoodsListPage: '搜索',
  collectStars: '集集乐',
  luckyWheelDetail: '大转盘',
  goldenEggs: '砸金蛋',
  scratch: '刮刮乐',
  numberOfStampsOrderDetail: '兑换优惠券',
  numberOfStampsUsed: '兑换优惠券',
  exchangeCouponDetail: '兑换优惠券',
  exchangeCouponDetailOrder: '兑换优惠券',
  previewSeckillOrder: '秒杀',
  seckillDetail: '秒杀',
  gpgoodsList: '拼团',
  gpgoodsDetail: '拼团',
  gpgroupDetail: '拼团',
  gpmyOrder: '拼团',
  gporderDetail: '拼团',
  gppaySuccess: '拼团',
  gpplaylaws: '拼团',
  previewGroupOrder: '预售',
  presellList: '预售',
  presellDetail: '预售',
  presellOrderDetail: '预售',
  presellOrderList: '预售',
  presellPaySuccess: '预售',
  previewPresellOrder: '预售',
  previewOrderDetail: '到店',
  paySuccess: '到店',
  tostoreOrderDetail: '到店',
  tostoreComment: '到店',
  makeTostoreComment: '到店',
  previewTakeoutOrder: '外卖',
  takeoutOrderDetail: '外卖',
  takeoutMakeComment: '外卖',
  orderTracking: '外卖',
  takeoutFeedback: '外卖',
  indemnityOrder: '外卖',
  cancelOrder: '外卖',
  checkRowNumberDetail: '排号组件',
  previewRowNumberOrder: '排号组件',
  rowNumberOrderDetail: '排号组件',
  promotionApply: '分销',
  promotionCommission: '分销',
  promotionGoods: '分销',
  promotionMyPromotion: '分销',
  promotionShopSetting: '分销',
  promotionTeam: '分销',
  promotionUserCenter: '分销',
  promotionWithdraw: '分销',
  promotionWithdrawRecord: '分销',
  promotionUserLevel: '分销',
  promotionLeaderPromotion: '分销',
  promotionMyIdentity: '分销',
  promotionWithdrawOffline: '分销',
  promotionWithdrawScreenshot: '分销',
  communityGroupAddGoods: '社区团购',
  communityGroupApply: '社区团购',
  communityGroupApplyStatus: '社区团购',
  communityGroupChildOrder: '社区团购',
  communityGroupGoodDetail: '社区团购',
  communityGroupOrder: '社区团购',
  communityGroupOrderDetail: '社区团购',
  communityGroupOrderSubmit: '社区团购',
  communityGroupPaySuccess: '社区团购',
  communityGroupSearchAddress: '社区团购',
  communityGroupSearchVillage: '社区团购',
  communityGroupWriteOff: '社区团购',
  communityGroupGoodsInfo: '社区团购',
  promotionSubShop: '分销',
  groupOrderDeta: '分销',
  dMCouponDetail: '微分商城',
  dMMerchantDetail: '微分商城',
  dMMerchantLocation: '微分商城',
  dMCouponsMall: '微分商城',
  dMUserCenter: '微分商城',
  dMUserInfoMod: '微分商城',
  dMCouponSuccess: '微分商城',
  dMCouponActive: '微分商城',
  dMWebView: '微分商城',
  dMMerchantAlbum: '微分商城',
  videoUsercenter: '视频',
  videoDetail: '视频',
  videoAssess: '视频',
  goodsMore: '',
  franchiseeDetail: '多商家',
  franchiseeTostore: '多商家',
  franchiseeEnter: '多商家',
  franchiseeEnterStatus: '多商家',
  franchiseeList: '多商家',
  franchiseePerfect: '多商家',
  franchiseeWaimai: '多商家',
  franchiseeCooperation: '多商家',
  franchiseeDetail4: '多商家',
  franchiseeFacility: '多商家',
  chainStoreList: '多商家',
  franchiseeSearch: '多商家',
  imgVideoView: '多商家',
  chainStoreList: '多商家',
  newAppointmentDetail: '行业预约',
  newAppointmentStandard: '行业预约',
  newAppointmentImgShow: '行业预约',
  newAppointmentOrder: '行业预约',
  newAppointmentOrderDetail: '行业预约',
  newAppointmentQrcode: '行业预约',
  hotel: '行业预约',
  houseList: '行业预约',
  calendar: '签到组件',
  retroactive: '签到组件',
  rule: '签到组件',
  communityPage: '社区',
  communityDetail: '社区',
  communityUsercenter: '社区',
  communityNotify: '社区',
  communityFailpass: '社区',
  communityReport: '社区',
  communityComments: '社区',
  newsDetail: '资讯',
  newsPocketsDetail: '资讯',
  newsCommentDetail: '资讯',
  newsPocketsBalance: '资讯红包',
}
const showNoDevToast = (router) => {
  const noName = '暂不支持当前功能';
  const yesName = <div><div>暂不支持</div><div>当前功能【{noDevPageList[router]}】</div></div>;
  Toast.info(noDevPageList[router] ? yesName : noName);
}
export {
  noDevPageList,
  showNoDevToast
}


// WEBPACK FOOTER //
// ./src/utils/noDevPageList.jsx